export enum ImagerySelectionTabs {
  Upload = "upload",
  SpaceNet = "spacenet",
}
export type UploadError = {
  file: File;
  error: Error;
};
